module.exports = __webpack_public_path__ + "img/special_attack.68c0c0a1.svg";